import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import { IRecommendationSettings } from '../types/recommendations.types';

dayjs.extend(utc);

export const roundedDate = (interval: number, date: dayjs.Dayjs = dayjs()) => {
  return dayjs(Math.ceil(+date / interval) * interval);
};

export const disabledPastDates = (date: dayjs.Dayjs, startDate: dayjs.Dayjs = dayjs()) => {
  return date.isBefore(startDate, 'day');
};

export const disabledPastTimes = (
  date: dayjs.Dayjs | null,
  startDate: dayjs.Dayjs = dayjs(),
  interval: number = 60000,
) => {
  const isToday = date?.isSame(startDate, 'day');
  const currentHour = startDate.hour();
  const currentMinute = startDate.minute();
  const disabledHours = () => {
    let hours: number[] = [];
    if (isToday) {
      for (let i = 0; i <= currentHour; i++) {
        if (currentHour === i) {
          roundedDate(interval, startDate).isAfter(startDate, 'hour') && hours.push(i);
        } else {
          hours.push(i);
        }
      }
    }
    return hours;
  };
  const disabledMinutes = (hour: number) => {
    let minutes: number[] = [];
    if (isToday && hour === currentHour) {
      for (let i = 0; i <= currentMinute; i++) {
        minutes.push(i);
      }
    }
    return minutes;
  };
  return {
    disabledHours,
    disabledMinutes,
  };
};

export const getUTCDate = (date?: string) => {
  if (!date) return;
  return dayjs.utc(date).local();
};

export const formatWorkTimeInterval = (val: IRecommendationSettings['workTimeInterval']) => {
  const format = 'YYYY-MM-DD HH:mm:ss';
  return getUTCDate(val.from)?.format(format) + ' - ' + (getUTCDate(val?.to)?.format(format) || 'X');
};
